export default __webpack_public_path__ + "static/media/arrow-left.ec30ed93.svg";